import { faBorderAll, type IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import type { Padding } from "../../../domain/types";

export const EMAIL_BUILDER_UNIFORM_SIDES_ICON: IconDefinition = faBorderAll;

export function emailBuilderSpacingIsUniform(value: Padding): boolean {
  return value.top === value.right && value.right === value.bottom && value.bottom === value.left;
}
